/*
 * Cookies system for NuxtJS (SSR and Client)
 * This module require [js-cookie] to be installed.
 * Author: ghostlexly@gmail.com - Tolga MALKOC
 */

import api from './js-cookie';

/** __constructor */
let $global_options = {};
let $cookies;
let $domain = document.domain.split('.').length === 2 ? '.' + document.domain : document.domain;
$global_options = {
	expires: 7, // 7 days
	domain: $domain,
};
$cookies = api.withAttributes($global_options); // set default options

/** main module */
let ghostlexly_cookies = {
	/**
	 * Get a cookie from name
	 *
	 * @param $name
	 */
	get: function ($name) {
		return $cookies.get($name);
	},

	/**
	 * Set a cookie
	 *
	 * @param $name
	 * @param $value
	 * @param $options
	 */
	set: function ($name, $value, $options = {}) {
		$cookies.set($name, $value, $options);
	},

	/**
	 * Delete a cookie
	 *
	 * @param $name
	 */
	remove: function ($name) {
		$cookies.remove($name);
	},
};

export default ghostlexly_cookies;
